import React from 'react'

const SiteOn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10.0009 3C7.5054 3 5.48242 5.05085 5.48242 7.5807C5.48242 9.00273 6.38947 10.2165 7.24173 11.3569L7.26402 11.3867L9.19983 13.9772C9.59977 14.5124 10.402 14.5124 10.8019 13.9772L12.7377 11.3867L12.76 11.3569C13.6123 10.2165 14.5193 9.00273 14.5193 7.5807C14.5193 5.05085 12.4964 3 10.0009 3Z" stroke="#01B5DE"/>
    <circle cx="10.0022" cy="7.5186" r="1.50615" stroke="#01B5DE"/>
    <path d="M12.5055 14.8325C13.2017 15.061 13.6372 15.3871 13.6372 15.749C13.6372 16.4401 12.0499 17.0002 10.092 17.0002C8.13409 17.0002 6.54688 16.4401 6.54688 15.749C6.54688 15.3871 6.98236 15.061 7.6785 14.8325" stroke="#01B5DE" stroke-linecap="round"/>
  </svg>
)

export default SiteOn;
